module.exports = __webpack_public_path__ + "static/motivebio-kit-box-061d36293f0f2c7425f3433f46fa7cf8.jpg";